module.exports = __webpack_public_path__ + "static/media/Data_Collection_Template.9ebfdab4.xlsx";